// extracted by mini-css-extract-plugin
export var divider = "_oj-0";
export var systemMessage = "_oj-1";
export var systemMessageWrapper = "_oj-2";